import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { Recipe } from '../../../queries/decoratedSilo';
import { siloDataKey } from '../use-query-silo-data';
import { dashboardDataKey } from '../../dashboard/use-query-dashboard-data';

/**
 * Invalidates the silo-data cache so the post-tx UI shows fresh state.
 *
 * The legacy optimistic-update path (which mutated a cached `DecoratedSilo`
 * keyed by `decoratedSiloKey`) was removed when the singular hook migrated to
 * the `/api/silo` endpoint. The `Recipe` parameter is retained for source-
 * compatibility with the existing action forms but is no longer consumed —
 * remove it together with the form-level recipe constructors when ready.
 */
export const useFinishTransaction = () => {
  const queryClient = useQueryClient();

  const finishTransaction = useCallback(
    (_recipe: Recipe) => {
      queryClient.invalidateQueries([siloDataKey], { refetchType: 'all' });
      queryClient.invalidateQueries([dashboardDataKey], { refetchType: 'all' });
    },
    [queryClient]
  );

  return finishTransaction;
};
